module.exports = __webpack_public_path__ + "img/geod_3.deb1300e.jpg";